import { Wizard } from '@cadstrom/cadstrom-shared';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { useTRPC } from '#src/trpc.js';

export const Route = createFileRoute('/_authorization-gate/wizard/admin/')({
	head: () => ({ meta: [{ title: 'General • Wizard Admin • Cadstrom' }] }),
	component: WizardAdminGeneralPage,
});

function WizardAdminGeneralPage() {
	const trpc = useTRPC();

	const {
		data: { avgStepCompletionTimes },
	} = useSuspenseQuery(trpc.wizard.statistics.queryOptions({}));

	return (
		<div className='flex min-h-0 grow flex-col gap-3 overflow-auto p-3'>
			<p className='font-semibold'>Average step completion times:</p>

			<div className='grid grid-cols-[repeat(auto-fill,minmax(10rem,1fr))] gap-3'>
				{Wizard.nonTestStepTypes.map((stepType) => {
					const completionTime = avgStepCompletionTimes[stepType];
					const completionTimeMins = completionTime === undefined ? '-' : Math.floor(completionTime / 60);
					const completionTimeSecs =
						completionTime === undefined ? '--' : String(Math.floor(completionTime % 60)).padStart(2, '0');
					return (
						<div
							key={stepType}
							className='flex min-w-0 flex-col items-center gap-3 rounded-md border border-blue-a4 bg-blue-a3 px-2 py-3'
						>
							<span className='font-mono'>{stepType}</span>
							<span className='text-xl font-bold tabular-nums'>
								{completionTimeMins}m{completionTimeSecs}s
							</span>
						</div>
					);
				})}
			</div>
		</div>
	);
}
